import React, {Component} from 'react';
import * as hooks from "../../../../../utils/hooks";
import * as func from "../../../../../utils/functions";
import ReactPaginate from "react-paginate";
import {BASE_PATH} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";
import Loading from "../../../../etc/loading";

class MAJournals extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'all',
			categoryType: 'register_type',
			categoryName: null
		}

		func.getData("code/search/" + this.state.categoryType, {}).then((response) => {
			let categoryName = {};
			response.records.map((r, i) => {
				categoryName[r.code_id] = r.code_name;
			});
			this.setState({categoryName: categoryName});
		});
	}

	render() {
		const records = this.props.records;
		const categoryName = this.state.categoryName;

		if (!records || !categoryName)
			return '';

		return (
			<div className="mt-65">
				<div className="d-flex justify-content-between align-items-center mb-px-26">
					<div className="d-flex align-items-center">
						<h3 className="con-title">주요 게재저널 리스트</h3>
					</div>
				</div>
				<div>
					<table className="table table-lightgray">
						<colgroup>
							<col width="38%"/>
							<col width="12%"/>
							<col width="10%"/>
							<col width="10%"/>
							<col width="10%"/>
							<col width="20%"/>
						</colgroup>
						<thead>
						<tr>
							<th scope="col" className="text-left">저널명</th>
							<th scope="col">저널영향력 지수</th>
							<th scope="col">논문 수</th>
							<th scope="col">인용 수</th>
							<th scope="col">평균 피인용</th>
							<th scope="col">등재정보</th>
						</tr>
						</thead>
						<tbody>
						{records.map((record, index) => {
							const register_db_types = record.register_db_type.split(',');

							return (
								<tr key={index}>
									<td className="text-left">
										<NavLink to={BASE_PATH + "journal/?record_id=" + record.journal_id}
										         className="item-subject">{record.journal_title}</NavLink>
									</td>
									<td>{record.impact}</td>
									<td>{record.publication_count}</td>
									<td>{record.cited_count}</td>
									<td>{record.avg_cited_count}</td>
									<td>
										{register_db_types.length > 0 &&
										<div className="badge-group-inner">
											{register_db_types.map((item, i) => {

												const title = categoryName[item];

												// item = item.toUpperCase()

												let className = 'badge bg-lightpurple';
												if (item === 'kci_can' || item === 'kci' || item === 'kci_great')
													className = 'badge bg-lightgreen';
												else if (item === 'Scopus')
													className = 'badge bg-lightorange';
												else if (item === 'nature_index')
													className = 'badge bg-skyblue';

												return ( <span key={index + '_' + i} className={className}>{title}</span> )
											})}
										</div>
										}
									</td>
								</tr>
							)
						})}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
};

export default MAJournals;
